import common from './common/en.js';
import sample from './sample/en.js';
import account from './account/en.js';

export default {
    common,
    sample,
    account,
};
